<eda-dialog2 [display]="display"
  header="Agregar nuevo tag" i18n-header="@@newTagPlaceholder" width="50vw" height="50vh"
  (apply)="saveTags()"
  (close)="closeDialog()">


  <div content> 
    <div class="grid space-y-5">
      <div class="">
        <label for="newTag" class="font-medium" i18n="@@newTagPlaceholder">Agregar nuevo tag</label>
        <input
          id="newTag"
          type="text"
          [(ngModel)]="newTag"
          class="add-tag-input w-full border rounded-md p-2"
        />
        <button class="add-tag-btn flex items-center gap-2 mt-2 px-4 py-2 bg-gray-200 text-gray-600 rounded-md" (click)="addItem()">
          <i class="fa fa-save"></i>
          <span i18n="@@addTagDataSource">Añadir Tag</span>
       </button>
      </div>

      <div class="">
        <label for="selectedTags" class="font-medium" i18n="@@selectedTags">
          Tags seleccionados
        <span class="text-red-500">*</span></label>
        <p-multiSelect
          id="selectedTags"
          [options]="tags"
          [(ngModel)]="selectedTags"
          [virtualScroll]="true"
          [itemSize]="30"
          i18n-defaultLabel="@@groupSelect"
          defaultLabel="Selecciona..."
          [style]="{width: '100%'}"
          [emptyMessage]="emptyMessageTags"
        ></p-multiSelect>
      </div>
    </div>
  </div>
  
</eda-dialog2>